<div class="date-range" [formGroup]="form">
  <div class="date-range__picker" [class.is-collision]="isCollision">
    <div class="date-range__box">
      <one-datepicker
        [formControlName]="CTRL.START_DATE"
        [min]="minimumStartDate"
        [label]="LABEL.START_DATE"
      ></one-datepicker>
      <button
        type="button"
        class="date-range__clear"
        *ngIf="hasStartDateValue"
        (click)="clearStartDate()"
        [attr.aria-label]="MSG.clearStartDate"
        [attr.title]="MSG.clearDate"
      >&times;</button>
    </div>
    <span class="date-range__error" *ngIf="messageErrorStartDate">{{ messageErrorStartDate }}</span>
  </div>

  <div class="date-range__picker" *ngIf="hasEndDate" [class.is-collision]="isCollision">
    <div class="date-range__box">
      <one-datepicker
        [formControlName]="CTRL.END_DATE"
        [min]="minimumEndDate"
        [max]="maximumDate"
        [label]="LABEL.END_DATE"
      ></one-datepicker>
      <button
        type="button"
        class="date-range__clear"
        *ngIf="hasEndDateValue"
        (click)="clearEndDate()"
        [attr.aria-label]="MSG.clearEndDate"
        [attr.title]="MSG.clearDate"
      >&times;</button>
    </div>
    <span class="date-range__error" *ngIf="messageErrorEndDate">{{ messageErrorEndDate }}</span>
  </div>
</div>

<span class="date-range__note" *ngIf="isCampaignManager">{{ campaignNote }}</span>
